import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { StyledSeeAllButton } from "./styled";

type SeeAllButtonProps = {
    onClick: () => void;
    dataTestId: string;
};

export const SeeAllButton: FC<SeeAllButtonProps> = ({ onClick, dataTestId }) => {
    const { t } = useTranslation();
    return (
        <StyledSeeAllButton type="button" onClick={onClick} className="btnText" data-testid={dataTestId}>
            {t("Common.SeeAll")}
        </StyledSeeAllButton>
    );
};
